<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="LINESPACE" id="ep"> </p>
<p class="LINESPACE"> </p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EP"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>I bleed by the black stream</i></span></p>
<p class="EP"><i>For my torn bough!</i></p>
<p class="EPC"><span class="small">JAMES JOYCE</span></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?03656735